import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SfaStageContainerModel } from '../../../../../models/aggregates/sfa/SfaStageContainer.model';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';

@Injectable({
  providedIn: 'root',
})
export class SfaStageService extends BaseApiTemplateService<SfaStageContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.SFA_MODULE_PREFIX +
    'stages';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.SFA_MODULE_PREFIX +
      'stages';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.SFA_MODULE_PREFIX +
      'stages';
    this.httpClient = http;
  }
}
